/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useRef} from 'react';

/**
 * @usePreviousState
 *
 * Simple hook for obtaining previous state value
 *
 * ```typescript
 * import {usePreviousState} from '@ion/dls/src/hooks/usePreviousState';
 *
 * //...in component,
 *
 *  const previous = usePrevious({accountId});
 *
 * ```
 *
 */
export const usePreviousState = <T extends unknown>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePreviousState;
